if (!customElements.get("marmeto-variants")) {
  class MarmetoVariants extends HTMLElement {
    constructor() {
      super();
      this.productHandle = this.dataset.productHandle;
      this.sectionId = this.dataset.sectionId;
      this.productId = this.dataset.productId;
      this.updateURL = this.dataset.updateUrl === "true" || false;

      this.variantData =
        JSON.parse(this.querySelector("[data-variant-holder]")?.textContent) ;
      this.addEventListener("change", (event) => this.onVariantChange(event));
    }

    async onVariantChange(event) {
      if (event.target.tagName === "SELECT") {
        this.currentVariant = this.getVariantFromSelect();
      } else if (event.target.type === "radio") {
        this.currentVariant = this.getVariantFromRadio();
      }

      if (this.currentVariant) {
        //flits has added below line of code

        window.refreshFlitsCredits(this.currentVariant.id);
        if (this.updateURL) this.updateProductURL();
        await this.fetchProductInfo();
      } else {
        this.setUnavailable();
      }
    }
    getVariantFromSelect() {
      const selectedOptions = Array.from(this.querySelectorAll("select")).map(
        (select) => select.value
      );
      return this.variantData.find((variant) =>
        selectedOptions.every(
          (option, index) => variant.options[index] === option
        )
      );
    }

    getVariantFromRadio() {
      const selectedOptions = Array.from(
        this.querySelectorAll('input[type="radio"]:checked')
      ).map((radio) => radio.value);
      return this.variantData.find((variant) =>
        selectedOptions.every(
          (option, index) => variant.options[index] === option
        )
      );
    }

    updateProductURL() {
      // Flits earn credit window object
      window.refreshFlitsCredits(this.currentVariant.id);
      this.url = new URL(window.location);
      this.url.searchParams.set("variant", this.currentVariant.id);
      window.history.replaceState({}, "", this.url);
    }

    async fetchProductInfo() {
      this.url = `/products/${this.productHandle}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`;
      //flits has added below line of code
      window.refreshFlitsCredits(this.currentVariant.id);
      try {
        const response = await fetch(this.url);
        const responseText = await response.text();
        this.html = new DOMParser().parseFromString(responseText, "text/html");
        this.renderProductInfo(this.html);
      } catch (error) {
        console.error("Error fetching product info:", error);
      }
    }

    renderProductInfo(section) {
      //flits has added below line of code
      window.refreshFlitsCredits(this.currentVariant.id);
      if (this.dataset.productCard) {
        this.closest("borosil-product-card").innerHTML = section.querySelector(
          `[data-product-variant-handle="${this.productHandle}"]`
        ).innerHTML;
      } else {
        document.querySelector(".main-product").innerHTML =
          section.querySelector(`.main-product`).innerHTML;
      }
    }

    setUnavailable() {
      const productForm = document.getElementById(
        `product-form--${this.sectionId}--${this.productId}`
      );
      const addButtonText = productForm.querySelector(
        '[name="add"] > .button--atc__text'
      );
      const price = document.getElementById(`price-${this.dataset.section}`);
      const inventory = document.getElementById(
        `Inventory-${this.dataset.section}`
      );
      const sku = document.getElementById(`Sku-${this.dataset.section}`);
      const pricePerItem = document.getElementById(
        `Price-Per-Item-${this.dataset.section}`
      );

      if (addButtonText) addButtonText.textContent = "Unavailable";
      [price, inventory, sku, pricePerItem].forEach((el) =>
        el?.classList.add("visibility-hidden")
      );
    }
  }

  customElements.define("marmeto-variants", MarmetoVariants);
}
